import "./index.css";     // ✔ CORRECTO
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// 🚀 AGREGADO: Provider de NeoToast
import NeoToastProvider from "./components/NeoToast";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <NeoToastProvider>
      <App />
    </NeoToastProvider>
  </React.StrictMode>
);

// 🔒 Protección contra extensiones que intenten borrar localStorage
const originalClear = localStorage.clear;
localStorage.clear = function () {
  console.warn("⚠️ Una extensión intentó limpiar localStorage. BLOQUEADO.");
  // NO ejecutar el borrado real
};

reportWebVitals();
